<template>
  <div class="actions">
    <Button icon="slides">View slides</Button>
  </div>
</template>

<style scoped>
.actions {
  margin: 84px 0 40px 0;
}
</style>

<script>
import Button from "./Button";

export default {
  components: { Button }
};
</script>